/**
 * Retorna clases de Tailwind para el color según el tipo de DTE.
 * @param {string|number} code - Código del documento (33, 34, 61, etc.)
 */
export const getDteColor = code => {
  const c = String(code)
  switch (c) {
    case '33': // Factura Electrónica
      return 'bg-blue-100 text-blue-700 border-blue-200'
    case '34': // Factura Exenta Electrónica
      return 'bg-emerald-100 text-emerald-700 border-emerald-200'
    case '39': // Boleta Electrónica
      return 'bg-amber-100 text-amber-700 border-amber-200'
    case '46': // Factura de Compra Electrónica
      return 'bg-indigo-100 text-indigo-700 border-indigo-200'
    case '52': // Guía de Despacho Electrónica
      return 'bg-lime-100 text-lime-700 border-lime-200'
    case '61': // Nota de Crédito Electrónica
      return 'bg-orange-100 text-orange-700 border-orange-200'
    case '80': // Boleta de Honorarios Electrónica
      return 'bg-purple-100 text-purple-700 border-purple-200'
    case '90': // Boleta de Honorarios a Terceros Electrónica
      return 'bg-pink-100 text-pink-700 border-pink-200'
    case '110': // Factura de Exportación Electrónica
      return 'bg-cyan-100 text-cyan-700 border-cyan-200'
    default:
      return 'bg-gray-100 text-gray-600 border-gray-200'
  }
}
